import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const drupalInterceptor: HttpInterceptorFn = (req, next) => {

  const isApiCall = req.url.startsWith(environment.api.baseUrl);

  const newReq = req.clone({
    headers: req.headers.set('apiKey', environment.api.apiKey)
  });

  return next(isApiCall ? newReq : req)
};
